import { LoginModal } from "@components/modal"
import { Container } from "@components/wrapper"
import { SchoolPortfolio } from "@interfaces/school"
import { useUserData } from "@lib/context/ComponentContext"
import clsx from "clsx"
import Image from "next/image"
import React, { useState } from "react"
import { FaArrowRight } from "react-icons/fa"
import Carousel from "react-multi-carousel"
import { BootcampSliderArrow, SliderScrollArrow } from "."
import { CustomDot } from "../general"
import ModalFileRequest from "../general/ModalFileRequest"
import { BootcampHeading } from "../general/ProgramHeading"

export const BootcampPortfolio = ({ portfolios, screenWidth }: { portfolios: SchoolPortfolio[], screenWidth: number }) => {
  // Slider breakpoint
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  const { isLogin, tokenData } = useUserData()

  const [openLogin, setOpenLogin] = useState(false)
  const [openSyllabus, setOpenSyllabus] = useState(false)
  const [portfolioId, setPortfolioId] = useState(-1)

  const openModal = (id: number) => () => {
    if (isLogin) {
      setOpenSyllabus(true)
      setPortfolioId(id)
    } else {
      setOpenLogin(true)
    }
  }


  if(!portfolios.length) {
    return <></>
  }

  
  return (
    <div className="bg-body-bg sm:py-20 py-10">
      <Container>
        <div className="sm:mb-9 mb-6 relative">
          <BootcampHeading
            id="portfolio"
            title="portofolio"
            subTitle="Yuk, Intip Hasil Karya dari Para Alumni"
          />
        </div>

        <div className="relative">
          <Carousel
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            containerClass={clsx("sm:-ml-4.5")}
            itemClass="sm:px-4.5"
            arrows={false}
            {...(screenWidth > 576 && {
              customButtonGroup: (
                <BootcampSliderArrow
                  length={portfolios.length}
                  displayedSlide={3}
                  className="gap-6 justify-center pt-6 -mb-4"
                />
              ),
              renderButtonGroupOutside: true,
              partialVisible: true,
            })}
            {...(screenWidth < 576 && {
              renderArrowsWhenDisabled: true,
              renderButtonGroupOutside: true,
              partialVisible: true,
              customButtonGroup: (
                <SliderScrollArrow
                  length={portfolios.length}
                  displayedSlide={1}
                  customBackground="bg-[#E9E9E9]"
                  customMargin="mt-6"
                />
              ),
              autoPlaySpeed: 3000,
            })}
            className="d-lg-flex d-none"
          >
            {portfolios.map((value) => (
              <div key={value.portfolio_id} className="rounded-lg card-box">
                <div>
                  <Image
                    src={value.portfolio_thumbnail}
                    alt={value.portfolio_title}
                    width={390}
                    height={215}
                    className="object-contain rounded-t-lg w-full"
                  />
                </div>

                <div className="p-6 bg-white rounded-b-lg">
                  <div
                    className="font-urbanist line-clamp-1 sm:text-xl text-lg text-black-22 font-bold"
                    title={value.portfolio_title}
                  >
                    {value.portfolio_title}
                  </div>
                  <div
                    className={clsx(
                      "sm:text-sm sm:h-[4.5em] sm:mb-6 line-clamp-3 text-black-48",
                      "text-xs leading-4 mb-3"
                    )}
                  >
                    {value.portfolio_description}
                  </div>
                  <button
                    className={clsx(
                      "flex items-center gap-2 text-blue font-semibold",
                      "sm-only:text-sm sm-only:mb-4"
                    )}
                    onClick={openModal(value.portfolio_id)}
                    id={`btn-download-portfolio-${value.portfolio_id}`}
                  >
                    Lihat Portofolio <FaArrowRight />
                  </button>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </Container>

      <ModalFileRequest
        data={tokenData}
        schoolId={portfolioId.toString()}
        show={openSyllabus}
        onHide={() => setOpenSyllabus(false)}
        mode="portfolio"
      />

      <LoginModal show={openLogin} onHide={() => setOpenLogin(false)} />
    </div>
  )
}
